"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const class_transformer_1 = require("class-transformer");
const nanoid_1 = require("nanoid");
const pokersolver_1 = require("pokersolver");
const rxjs_1 = require("rxjs");
const PlayerEvent_1 = require("../messaging/event/PlayerEvent");
const EventSourced_1 = require("../messaging/EventSourced");
const util_1 = require("../util");
const ActionEvaluator_1 = require("./ActionEvaluator");
const Bet_1 = require("./Bet");
const PlayerState_1 = require("./states/PlayerState");
const PlayerStateAction_1 = require("./states/PlayerStateAction");
const PlayerStateReducer_1 = require("./states/PlayerStateReducer");
const config = {
    DEFAULT_CHIP_COUNT: 10000,
};
const nanoid = nanoid_1.customAlphabet('0123456789', 9);
const nanoPlayerId = () => {
    return `${1 + parseInt(nanoid(), 10)}`;
};
class Player extends EventSourced_1.Evented {
    constructor(name, chips = config.DEFAULT_CHIP_COUNT, userId, userRoles, subscriber, id = nanoPlayerId(), rankedHandName, rankedHandDescription) {
        super(id);
        this.name = name;
        this.userId = userId;
        this.userRoles = userRoles;
        this.id = id;
        this.actions = [];
        this.bet = 0;
        this.bets = [];
        this.cards = [];
        this.state = PlayerState_1.PlayerStates.Waiting;
        this.missedBlinds = false;
        this.seatId = 0;
        this.playerOutTime = 0;
        this.buyIn = true;
        this.event$ = new rxjs_1.Subject();
        this.chips = chips;
        this.rankedHandName = this.cards.length > 0 ? rankedHandName : '';
        this.rankedHandDescription =
            this.cards.length > 0 ? rankedHandDescription : '';
        this.doNoActionCount = 0;
        this.color = '';
        this.role = '';
        if (subscriber) {
            this.event$.subscribe(subscriber);
        }
        this.update(PlayerEvent_1.PlayerEvents.created(this));
    }
    payBet(bet) {
        let betAmount = bet.amount;
        if (this.chips - betAmount <= 0) {
            betAmount = this.chips;
        }
        this.chips -= betAmount;
        this.bet += betAmount;
        this.bets.push(new Bet_1.Bet(betAmount, bet.kind));
        this.update(PlayerEvent_1.PlayerEvents.paidBet(this));
        return betAmount;
    }
    getCards(cards) {
        this.cards = this.cards.concat(cards);
        this.update(PlayerEvent_1.PlayerEvents.receivedCards(this));
    }
    returnCards() {
        this.resetPlayer();
        this.update(PlayerEvent_1.PlayerEvents.returnedCards(this));
    }
    showCards() {
        return this.cards;
    }
    hasCards() {
        return this.cards.length > 0;
    }
    setRankedHand(communityCards) {
        if (this.cards.length > 0) {
            try {
                const hand = pokersolver_1.Hand.solve([...this.cards, ...communityCards]);
                hand.playerId = this.getId();
                this.rankedHand = hand;
                this.rankedHandName = hand.name;
                this.rankedHandDescription = hand.descr;
            }
            catch (err) {
                util_1.logger.error(err);
            }
        }
    }
    setSeatId(seatId) {
        this.seatId = seatId;
    }
    setBuyIn() {
        this.buyIn = false;
    }
    getSeatId() {
        return this.seatId;
    }
    buyChips(chips) {
        if (chips > 0) {
            this.chips += chips;
        }
        this.update(PlayerEvent_1.PlayerEvents.buyChips(this));
    }
    setActions(actions) {
        this.actions = actions;
    }
    clearActions() {
        this.actions = [];
    }
    beginPlay() {
        this.update(PlayerEvent_1.PlayerEvents.beganPlay(this));
    }
    fold() {
        this.foldPlayer();
        this.update(PlayerEvent_1.PlayerEvents.fold(this));
    }
    goAllIn() {
        this.update(PlayerEvent_1.PlayerEvents.allin(this));
    }
    sitOut() {
        this.resetPlayer();
        this.update(PlayerEvent_1.PlayerEvents.sitout(this));
    }
    wait() {
        this.update(PlayerEvent_1.PlayerEvents.waiting(this));
    }
    foreverOut() {
        this.update(PlayerEvent_1.PlayerEvents.foreverOut(this));
    }
    disconnect() {
        this.update(PlayerEvent_1.PlayerEvents.disconnected(this));
    }
    observer() {
        this.update(PlayerEvent_1.PlayerEvents.observer(this));
    }
    onPokerPlayerCreated(event) {
        util_1.logger.trace('OnPokerPlayerCreated');
        this.setId(event.player.id);
        this.chips = event.player.chips;
        this.name = event.player.name;
        this.userId = event.player.userId;
        this.userRoles = event.player.userRoles;
    }
    onPokerPlayerBegan_play() {
        util_1.logger.trace('OnPokerPlayerBeganPlay');
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.BeginPlay, this.state);
    }
    onPokerPlayerFolded() {
        util_1.logger.trace('OnPokerPlayerFolded');
        this.foldPlayer();
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.Fold, this.state);
    }
    onPokerPlayerAllin() {
        util_1.logger.trace('OnPokerPlayerAllin');
        this.playerOutTime = this.currentCheckpoint();
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.GoAllIn, this.state);
    }
    onPokerPlayerSitout() {
        util_1.logger.trace('OnPokerPlayerSitout');
        this.resetPlayer();
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.SitOut, this.state);
    }
    onPokerPlayerWaiting() {
        util_1.logger.trace('OnPokerPlayerWaiting');
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.Wait, this.state);
    }
    onPokerPlayerForeverout() {
        util_1.logger.trace('onPokerPlayerForeverout');
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.OutForever, this.state);
    }
    onPokerPlayerDisconnected() {
        util_1.logger.trace('OnPokerPlayerDisconnected');
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.Disconnect, this.state);
    }
    onPokerPlayerObserver() {
        util_1.logger.trace('onPokerPlayerObserver');
        this.state = PlayerStateReducer_1.PlayerReducer(PlayerStateAction_1.PlayerActions.Observ, this.state);
    }
    onPokerPlayerPaid_bet(event) {
        util_1.logger.trace('OnPokerPlayerPaid_bet');
        this.chips = event.player.chips;
    }
    onPokerPlayerReceived_cards(event) {
        util_1.logger.trace('OnPokerPlayerReceived_cards');
        this.cards = event.player.cards;
    }
    onPokerPlayerReturned_cards() {
        util_1.logger.trace('OnPokerPlayerReturned_cards');
        this.resetPlayer();
    }
    onPokerPlayerBuyin(event) {
        util_1.logger.trace('OnPokerPlayerBuyin');
        this.chips = event.player.chips;
    }
    onPokerPlayerDonoaction(event) {
        util_1.logger.trace('onPokerPlayerDonoaction');
    }
    isAllIn() {
        return PlayerState_1.PlayerStates.isAllIn(this.state);
    }
    isFolded() {
        return PlayerState_1.PlayerStates.isFolded(this.state);
    }
    isInPlay() {
        return PlayerState_1.PlayerStates.isInPlay(this.state);
    }
    isSittingOut() {
        return PlayerState_1.PlayerStates.isOut(this.state);
    }
    isWaiting() {
        return PlayerState_1.PlayerStates.isWaiting(this.state);
    }
    isForeverOut() {
        return PlayerState_1.PlayerStates.isForeverOut(this.state);
    }
    isDisconnected() {
        return PlayerState_1.PlayerStates.isDisconnected(this.state);
    }
    isObserver() {
        return PlayerState_1.PlayerStates.isObserver(this.state);
    }
    isTeachingObserver() {
        return this.isObserver() && this.observerId === 1;
    }
    canCheck() {
        return (this.actions.filter((action) => {
            return action === ActionEvaluator_1.ActionHint.CHECK;
        }).length === 1);
    }
    canFold() {
        return (this.actions.filter((action) => {
            return action === ActionEvaluator_1.ActionHint.FOLD;
        }).length === 1);
    }
    doNoAction() {
        this.update(PlayerEvent_1.PlayerEvents.doNoAction(this));
    }
    update(event) {
        this.updateState(event);
        this.event$.next(event);
    }
    internalState() {
        return this.state.tag;
    }
    getId() {
        return super.getId();
    }
    getVersion() {
        return super.getVersion();
    }
    getEvents() {
        return super.getEvents();
    }
    resetBets() {
        this.bet = 0;
        this.bets = [];
    }
    resetPlayer() {
        util_1.logger.trace(`resetPlayer`);
        this.cards = [];
        this.rankedHand = undefined;
        this.rankedHandName = '';
        this.rankedHandDescription = '';
        this.actions = [];
        this.doNoActionCount = 0;
    }
    foldPlayer() {
        util_1.logger.trace(`foldPlayer`);
        this.rankedHand = undefined;
        this.actions = [];
    }
    static fromPlayerEntity(entity) {
        return new Player(entity.name, entity.chips, entity.userId, entity.userRoles, null, entity.id);
    }
}
__decorate([
    class_transformer_1.Transform(({ value }) => value.map((val) => ActionEvaluator_1.ActionHint[val.toUpperCase()])),
    __metadata("design:type", Array)
], Player.prototype, "actions", void 0);
__decorate([
    class_transformer_1.Type(() => Bet_1.Bet),
    __metadata("design:type", Array)
], Player.prototype, "bets", void 0);
__decorate([
    class_transformer_1.Exclude(),
    __metadata("design:type", typeof (_a = typeof pokersolver_1.SolvedHand !== "undefined" && pokersolver_1.SolvedHand) === "function" ? _a : Object)
], Player.prototype, "rankedHand", void 0);
__decorate([
    class_transformer_1.Type(() => PlayerState_1.PlayerStates),
    __metadata("design:type", Object)
], Player.prototype, "state", void 0);
__decorate([
    class_transformer_1.Type(() => rxjs_1.Subject),
    __metadata("design:type", Object)
], Player.prototype, "event$", void 0);
exports.Player = Player;
//# sourceMappingURL=Player.js.map